import { IPriceList } from 'redux/reducers/priceList/type';

export const getListsPriceList = (priceList: IPriceList): {
  listAmounts: number[];
  listTerms: number[];
} => {
  const listTerms = Object.keys(priceList).map(item => +item);
  const listAmounts = Object.keys(priceList[listTerms[0]]).map(item => +item);

  return {
    listAmounts,
    listTerms
  };
};
